import config from "config/appConfig";

import { SupportedLanguages } from "shared/types";
import type { IStateProps } from "utils/StateOf";
import createStore from "utils/createStore";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.LANGUAGE_DATA}`;

export interface Values {
	activeLanguage: SupportedLanguages;
}

export const initialState: IStateProps<Values> = {
	activeLanguage: SupportedLanguages.ENGLISH
};

export default createStore<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
